var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7321_20535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.177 4.99502C13.1476 4.29263 12.4048 3.16841 12.173 1.85869C12.123 1.5758 12.0952 1.28436 12.0952 0.986328H8.80966L8.80409 14.7661C8.74921 16.3094 7.53551 17.5477 6.04776 17.5477C5.58534 17.5477 5.15 17.427 4.76657 17.2155C3.88734 16.7316 3.2855 15.7673 3.2855 14.6578C3.2855 13.064 4.52479 11.7671 6.04739 11.7671C6.33181 11.7671 6.60437 11.8164 6.86209 11.9006V8.39057C6.5951 8.35216 6.32403 8.32887 6.04739 8.32887C2.71295 8.32887 0 11.1676 0 14.6578C0 16.7987 1.02199 18.6936 2.58204 19.8392C3.56399 20.5614 4.75915 20.9863 6.04776 20.9863C9.38258 20.9863 12.0952 18.1473 12.0952 14.6578V7.66994C13.3838 8.63777 14.9627 9.20822 16.6667 9.20822V5.76959C15.7489 5.76959 14.8941 5.48437 14.177 4.99502Z",
    fill: "#FFFFFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7321_20535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6667,
    height: 20,
    fill: "white",
    transform: "translate(0 0.986328)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.b164fbe85094b454ddc6cf4201666fc4.svg";
export { ForwardRef as ReactComponent };